<template>
  <div class="todo">
    <div class="task-remind">任务反馈</div>
    <!-- <div class="s-title">填写某篇课文的文化内涵梳理表</div> -->
    <div class="activity-list">
      <span :class="activityCurrent==index?'activityAct':'activitySpan'" v-for="(item,index) in activityList"
            :key="index" @click="changeActivity(item,index)">活动{{ format.number2Text(index) }}</span>
    </div>
    <div class="activity-detail">
      <div class="titleText" :style="{ 'max-height': status ? textHeight : '' }" :class="{ statusText: status }"
           ref="desc">
        <span v-html="activityMess.activityContent"></span>
      </div>
      <span v-if="idShowText" @click="status = !status" :class="{ openSpan: status }"
            class="openClose">{{ status ? "展开" : "收起" }}</span>
    </div>
    <div class="reply-detail">
      回答详情
    </div>
    <div class="class-list">
      <div class="list-l">
        <span v-for="(item, index) in classList" @click="changeClass(item,index)" :key="index">
          <a-tooltip placement="topLeft" :title="item.name">
            <span :class="classCurrent==index?'classSpan':'classAct'">{{ item.name }}</span>
          </a-tooltip>
        </span>
        <a-input-search placeholder="输入学生姓名快速检索" size="small" style="width: 190px;border-radius: 2px;"
                        @search="onSearch"/>
      </div>
      <div class="list-r">
        <img class="img-jz" src="@/assets/image/task-deadline.png" alt=""/>
        <span class="time-jz">截止时间：</span>
        <span v-show="editTimeFlag" class="time-number">{{ format.formatHour(endDate) }}</span>
        <a-date-picker size="small" v-show="!editTimeFlag" style="margin-left: 2px;" :disabledDate="disabledDate"
                       show-time placeholder="请选择截止时间" @change="timeChange" @ok="timeOk"/>
        <span class="time-edit" @click="editTime" v-if="false">修改</span>
        <img class="img-jz" src="@/assets/image/qxsz.png" alt=""/>
        <span class="qx-text" @click="classSetFun">权限设置</span>
      </div>
    </div>
    <div class="table">
      <a-table :columns="columns" :dataSource="tableList" :pagination="false" :rowKey="(record,index)=>{return index}">
        <span slot="reviseUserNames" slot-scope="text,record">
          {{ record.reviseUserNames === null ? '' : record.reviseUserNames[0] }}
        </span>
        <span slot="groupName" slot-scope="text,record">
          {{ record.groupName == null ? '' : record.groupName }}
        </span>
        <div slot="recommendedPermission" slot-scope="text,record">
          <a-tooltip placement="topLeft" title="已公开推荐">
            <img class="recommend" v-if="record.isGood===1&&record.recommendedPermission === 2"
                 src="@/assets/imgs/teacherRoadImg/recommend_public.png" alt="" style="width: 20px;width: 20px">
          </a-tooltip>
          <a-tooltip placement="topLeft" title="已推荐至班级">
            <img class="recommend" v-if="record.isGood===1&&record.recommendedPermission === 1"
                 src="@/assets/imgs/teacherRoadImg/recommend_class.png" alt="" style="width: 20px;width: 20px">
          </a-tooltip>
        </div>
        <span slot="userName" slot-scope="text,record">
          {{ record.userName == null ? '' : record.userName }}
        </span>
        <a-rate slot="star" slot-scope="text,record" style="color:@primary-color;" disabled v-model="record.star"
                v-if="record.star!=null">

        </a-rate>
        <span slot="commitDate" slot-scope="text,record"
              :class="endDate>record.commitDate?'commitDateNor':'commitDateRed'">
          {{ format.formatHour(record.commitDate) }}
        </span>
        <span class="ant-dropdown-link" slot="isClassStuRevise" slot-scope="text,record" @click="getRole(record)">
          {{ record.isClassStuRevise == 1 ? '班级可见' : '老师可见' }}
          <a-icon type="down"/>
        </span>
        <span slot="workStatus" slot-scope="text,record">  {{
            record.workStatus === 0 ? "未提交" : (record.workStatus === 1 ? "待批改" : (record.workStatus === 2 ? "已打回" : (record.workStatus === 3 ? "已重做" : "已批改")))
          }}</span>
        <span slot="action" slot-scope="text,record" class="action">
          <span @click="goDetail(record,true)">查看</span>
          <span class="correctGo" @click="pgFun(record, false)"> 批改</span>
          <span class="correctDis" @click="commitHistory(record)"> 提交记录 </span>
          <span :class="record.workStatus===4?'correctDis':'feedBack-no'"
                @click="recommandFun(record)"> {{ record.isGood == 1 ? '取消推荐' : '推荐' }} </span>
        </span>
      </a-table>
      <div style="display:flex; margin-top:15px;">
        <div style="color:#999;">
          共{{ total }}人回答
        </div>
        <div style="margin-left: auto;">
          <a-config-provider>
            <a-pagination :default-current="1" show-size-changer :page-size="pageSize"
                          :page-size-options="pageSizeOptions" :current="pageNum" @change="changePageNum"
                          @showSizeChange="onShowSizeChange" :total='total'/>
          </a-config-provider>
        </div>
      </div>
    </div>

    <!-- 查看详情-->
    <a-modal title="查看详情" :visible="taskDetailVis" destroyOnClose @cancel="()=>{this.taskDetailVis = false}"
             width="800px"
             footer="" centered>
      <div class="replay">
        <div class="author">
          <img class="author-img" src="@/assets/imgs/teacherRoadImg/06.png" alt="">
          <span class="author-name">{{ correctDetail.userName }}</span>
        </div>
        <!--        <div class="content" v-html="correctDetail.answerContent"></div>-->
        <rich-text-view class="content"
                        :content='correctDetail&&correctDetail.answerContent'
                        :images="correctDetail.imageList||[]"
                        :videos="correctDetail.videoList||[]"
                        :audios="correctDetail.audioList||[]"
                        :is-edit="false"
        ></rich-text-view>
        <a-divider/>
        <span class="text">全部评价：</span>
        <div class="file-list" v-for="(detail,index1) in correctDetail.revises" :key="index1">
          <a-col style="width: 100%">
            <div class="pj">
              <img class="userImg" :src="detail.photo&&detail.photo!=null?imgUrlHead+'/'+detail.photo: mrPhoto"
                   alt=""/>
              <span class="stu">{{ (detail.userName) || '' }}</span>
              <span>
                <a-rate style="color:@primary-color;" :disabled="true" v-model="detail.star"/>
              </span>
            </div>
            <div class="pj-detail">{{ (detail.content) || '' }}</div>
            <viewer class="file-div" v-for="(item,index) in detail.imageList" :key="index">
              <img class="file-img" :src="resBasePath+'/'+item.path">
            </viewer>
            <a-row class="time">
              <span class="time-number">{{ format.formatHour(detail.createDate) }}</span>
              <div class="text" @click="praise(detail)">
                <img class="praise" v-if="detail.isPraise === 1" src="@/assets/imgs/teacherRoadImg/24-1.png" alt="">
                <img class="praise" v-if="detail.isPraise === 0" src="@/assets/imgs/teacherRoadImg/24-2.png" alt="">
                <span>{{ detail.praiseCount || '' }}</span>
              </div>
            </a-row>
            <a-divider/>
          </a-col>
        </div>
        <a-empty v-if="correctDetail==null||correctDetail.revises==null||correctDetail.revises.length === 0"/>
      </div>
    </a-modal>
    <!-- 活动批改-->
    <a-modal title="活动批改" :visible="replayVis" destroyOnClose @cancel="()=>{this.replayVis = false}" width="1000px"
             footer="" centered>
      <div class="replay">
        <div class="author">
          <img class="author-img" src="@/assets/imgs/teacherRoadImg/06.png" alt="">
          <span class="author-name">{{ correctDetail && correctDetail.userName }}</span>
        </div>
        <!--        <div class="content" v-html="correctDetail&&correctDetail.answerContent"></div>-->
        <rich-text-view class="content"
                        :content='correctDetail&&correctDetail.answerContent'
                        :images="correctDetail.imageList||[]"
                        :videos="correctDetail.videoList||[]"
                        :audios="correctDetail.audioList||[]"
                        :is-edit="true"
                        @editImage="doImageEdit"
        ></rich-text-view>
        <!--        <div class="file-list" v-if="correctDetail&&correctDetail.imageList&&correctDetail.imageList.length>0">-->
        <!--          <viewer class="file-div" v-for="(item,index) in correctDetail.imageList" :key="index">-->
        <!--            <img class="file-img" :src="resBasePath+'/'+item.path" @click="doImageEdit(resBasePath+'/'+item.path)">-->
        <!--          </viewer>-->
        <!--        </div>-->
        <a-divider/>
        <div v-if="look">
          <div class="pj">
            <!--              <span class="stu">{{ correctDetail.revises && correctDetail.revises.userName }}</span>-->
            <span class="text">评价：</span>
            <span>
                <a-rate style="color:@primary-color;" v-model="starValue"/>
              </span>
          </div>
          <div class="pj-detail">
            <!--              {{ correctDetail.revises[0] && correctDetail.revises[0].content }}-->
          </div>
        </div>
        <div v-if="!look">
          <div class="pj">
            <span class="text">作品评价：</span>
            <span>
                <a-rate style="color:@primary-color;" v-model="correctDetail.star" @change="starRange"/>
              </span>

            <div class="pj-right">
              <!-- <span class="text-pz">作品批注</span>
                        <div class="good">
                            <span class="number">{{correctDetail&&correctDetail.praiseNumber || 0}}</span>
                            <img v-if="correctDetail&&correctDetail.isPraise === 1" src="@/assets/imgs/teacherRoadImg/24-1.png" alt="">
                            <img v-if="correctDetail&&correctDetail.isPraise === 0" src="@/assets/imgs/teacherRoadImg/24-2.png" alt="">
                        </div> -->
              <div class="rec">
                <a-checkbox @change="setGoodChange" :checked="this.isGood===1">
                  推荐该作品
                </a-checkbox>
              </div>
              <div>
                <a-tooltip placement="topLeft">
                  <template slot="title">
                    <span>全网公开：全网可见；班级可见：仅班级内学生可见。</span>
                  </template>
                  <span style="margin-left: 1px">可见范围：<a-icon type="info-circle"/></span>
                </a-tooltip>
                <a-select style="width: 100px;margin-left: 8px;" class="select-rolef" v-model="classType">
                  <a-select-option :value="1"> 班级可见</a-select-option>
                  <a-select-option :value="2"> 全网公开</a-select-option>
                </a-select>
              </div>
            </div>
          </div>
          <div class="pj-detail" style="min-height: 80px;">
            <a-textarea placeholder="" v-model="correctContent" :auto-size="{ minRows: 3, maxRows: 6 }"/>
          </div>
          <div class="file-list" v-if="fileList.length>0">
            <viewer class="file-div" v-for="(item,index) in fileList" :key="index">
              <img class="file-img" :src="resBasePath+'/'+item.path">
              <img @click="delFun(index)" class="del" src="../../../../assets/image/27.png" alt="">
            </viewer>
          </div>
          <div class="footer">
            <a-upload v-if="false" name="file" :show-upload-list="false" :before-upload="beforeUpload">
                <span class="upload-btn">
                  <img class="add" src="@/assets/image/uploadWork.png" alt=""/>
                </span>
            </a-upload>

            <div class="fun-btn">
              <a-button v-if="false" class="save" @click="saveFun">保存</a-button>
              <a-button class="save" @click="reback()" v-if="pgWorkStatus !== 4" >打回重做</a-button>
              <a-button type="primary" class="fb" @click="publishFun">提交批改</a-button>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <!-- 推荐作品-->
    <a-modal title="推荐作品" :visible="recommandVis" :destroyOnClose="true" @cancel="()=>{this.recommandVis = false}"
             width="400px" footer="" centered>
      <div>
        <a-radio-group v-model="recommendValue">
          <a-radio :style="radioStyle" :value="1">
            班级可见：班级内成员可在优秀作品区查看该生作品；
          </a-radio>
          <a-radio :style="radioStyle" :value="2">
            全网公开：全平台用户可在优秀作品区查看该生作品；
          </a-radio>
        </a-radio-group>
      </div>
      <div class="qx-footer">
        <a-button class="qx-cancel" @click="()=>{this.recommandVis = false}">取消</a-button>
        <a-button class="qx-sure" @click="recommandSure" type="primary">确认</a-button>
      </div>
    </a-modal>
    <!-- 全局权限设置-->
    <a-modal title="权限设置" :visible="classVis" :destroyOnClose="true" @cancel="()=>{this.classVis = false}"
             width="400px" footer="" centered>
      <div>
        <a-radio-group v-model="classValue">
          <a-radio :style="radioStyle" :value="0">
            老师可见：班级内成员无法看到和批改学生作品；
          </a-radio>
          <a-radio :style="radioStyle" :value="1">
            班级可见：班级内成员可以看见并批改学生作品；
          </a-radio>
        </a-radio-group>
      </div>
      <div class="qx-footer">
        <a-button class="qx-cancel" @click="()=>{this.classVis = false}">取消</a-button>
        <a-button class="qx-sure" @click="globalPermission" type="primary">确认</a-button>
      </div>
    </a-modal>
    <!-- 单个权限设置-->
    <a-modal title="权限设置" :visible="personVis" :destroyOnClose="true" @cancel="()=>{this.personVis = false}"
             width="400px" footer="" centered>
      <div>
        <a-radio-group v-model="personvalue">
          <a-radio :style="radioStyle" :value="0">
            老师可见：班级内成员无法看到和批改学生作品；
          </a-radio>
          <a-radio :style="radioStyle" :value="1">
            班级可见：班级内成员可以看见并批改学生作品；
          </a-radio>
        </a-radio-group>
      </div>
      <div class="qx-footer">
        <a-button class="qx-cancel" @click="()=>{this.personVis = false}">取消</a-button>
        <a-button class="qx-sure" @click="singlePermission" type="primary">确认</a-button>
      </div>
    </a-modal>
    <!-- 提交记录-->
    <div v-if="submitRecordsVisible">
      <a-modal
          title="提交记录"
          :visible="submitRecordsVisible"
          :footer="null"
          width="1000px"
          @cancel="submitRecordshandleCancel"
          centered
      >
        <div class="records-time-box">
          <div class="submite-info" v-if="submitInfo.answerList">
            <!--                <a-tabs default-active-key="1" @change="submitRecordtabBack">-->
            <!--                    <a-tab-pane v-for="(submitInfoItem ,index) in submitInfo.answerList" :key="index" :tab="`活动${format.number2Text(index)}`">-->
            <a-timeline v-if="submitInfo.answerList">
              <a-timeline-item v-for="(submitInfoItem, index) in submitInfo.answerList" :key="index">
                <div class="submit-info">
                  <div class="submit-info-top">
                    <div class="submit-info-top-left">
                      <span class="sub-num">第{{
                          format.number2Text(submitInfo.answerList.length - index - 1)
                        }}次提交</span>
                      <span class="sub-time">{{ format.format(submitInfoItem.commitDate) }}</span>
                    </div>
                    <div class="submit-info-top-right" v-if="index==0">
                      <span class="sub-state">当前状态：</span>
                      <span style="color: #DB5647;"> {{
                          submitInfo.workStatus === 0 ? "未提交" : (submitInfo.workStatus === 1 ? "待批改" : (submitInfo.workStatus === 2 ? "已打回" : (submitInfo.workStatus === 3 ? "已重做" : "已批改")))
                        }}</span>
                    </div>
                  </div>
                  <div class="submit-info-content-box">
                    <!--                    <richText class="submit-info-content" v-html="submitInfoItem.writingContent"></richText>-->
                    <!--                              <div class="submit-info-seeAll" @click="submitSeeAll(submitInfoItem)">查看全文</div>-->
                    <rich-text-view class="content"
                                    :content='submitInfoItem&&submitInfoItem.writingContent'
                                    :images="submitInfoItem.imageList||[]"
                                    :videos="submitInfoItem.videoList||[]"
                                    :audios="submitInfoItem.audioList||[]"
                                    :is-edit="false"
                    ></rich-text-view>
                  </div>
                  <div class="sub-comments" v-if="submitInfoItem.revise">
                    <div class="sub-wenzi">批注：</div>
                    <richText class="sub-comments-content" v-html="submitInfoItem.revise.content"></richText>
                    <div v-if="submitInfoItem.revise.imageList" style="text-align: left;margin-top: 20px">
                      <img
                          v-for="(image, i) in submitInfoItem.revise.imageList"
                          :src="resBasePath +'/'+ image.path"
                          :Key="i"
                          width="80%"
                          style="width: 136px;height: 60px; padding-right: 20px"
                      />
                    </div>
                    <div v-if="submitInfoItem.revise.audioList" style="text-align: center">
                      <div v-for="audio in submitInfoItem.revise.audioList" :key="audio.id">
                        <audio controls :src="resBasePath + audio.path"/>
                        <p v-if="audio.name">{{ audio.name }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </a-timeline-item>
            </a-timeline>
            <a-empty v-if="submitInfo.answerList.length === 0"/>
            <!--                    </a-tab-pane>-->

            <!--                </a-tabs>-->
          </div>
        </div>
      </a-modal>
    </div>
    <!-- 取消推荐-->
    <a-modal title="取消推荐" :visible="cancelGood" @cancel="() => { this.cancelGood = false }" width="460px"
             footer="" centered>
      <div class="wj-new">
        <div class="del-text" style="margin-top: 15px">取消推荐学生作品？</div>
      </div>
      <div class="qx-footer">
        <a-button class="qx-cancel" @click="() => { this.cancelGood = false }">取消</a-button>
        <a-button class="qx-sure" @click="cancelGoodSure" type="primary">确定</a-button>
      </div>
    </a-modal>
    <!-- 图片批注-->
    <a-modal v-model="imgEditorVisible" class="image-modal" title="图片批注" width="70vw" :footer="null" centered>
      <image-editor :in-src="inSrc" @imgUrl="getUrlImg"></image-editor>
    </a-modal>
  </div>
</template>

<script>
import format from '@/utils/format.js'
import requestUrl from '@/utils/requestUrl.js'
import moment from 'moment'
import axios from 'axios'
import ImageEditor from '@/components/ImageEditor.vue'
import RichTextView from '../../../../components/richTextView.vue'

export default {
  name: 'taskFeedBack',
  data () {
    return {
      format,
      requestUrl,
      columns: [],
      tableList: [],
      resBasePath: this.$resBasePath,
      activityList: this.$store.state.taskFeedBackMess.activityList,
      activityMess: this.$store.state.taskFeedBackMess.activityList[0] || {},
      activityId: this.$store.state.taskFeedBackMess.activityList[0].id || {},
      classId: '',
      userName: '',
      classList: [],
      endDate: 0, // 截止时间
      taskId: '',
      activityCurrent: 0,
      classCurrent: 0,
      size: '',
      roleType: '',
      isReviseFlag: false, // 0 false未批改 1 true已批改
      pageSize: 10,
      pageNum: 1,
      total: 0,
      replayVis: false,
      recommandVis: false, // 推荐作品弹窗
      starValue: 3,
      pgWorkStatus: -1,
      look: true,
      classType: 1,
      recommentClassType: '2',
      classVis: false,
      classValue: 0,
      recommendValue: 1,
      radioStyle: {
        display: 'block',
        height: '30px',
        lineHeight: '30px'
      },
      personFlag: true,
      correctDetail: {
        userName: ''
      }, // 批改详情
      correctContentList: ['每次作业都力求做的更漂亮！', ' 认真的程度再高一些，你的收获就会更多一些！', ' 每天前进一小步，你终会走向成功！'], // 批改的内容
      correctContent: '', // 批改的内容
      commenttContent: '', // 推荐语作为评语
      isGood: 0, // 是否推荐 默认不推荐0 推荐为1
      viewPermission: 2,
      personvalue: 0,
      personVis: false,
      userAnswerId: '',
      editFlag: true,
      textHeight: null,
      status: false,
      idShowText: false,
      pageSizeOptions: ['10', '20', '50'],
      fileList: [],
      editTimeFlag: true,
      cancelGood: false, // 取消推荐
      imgEditorVisible: false, // 图片编辑弹窗
      timeDate: '',
      submitInfo: {}, // 提交信息详情
      submitRecordsVisible: false, // 提交记录弹窗
      taskDetailVis: false, // 任务详情弹窗
      access_token: this.$getUserInfo().access_token,
      userId: this.$getUserInfo().id,
      imgUrlHead: this.$resBasePath, // 图片前缀
      mrPhoto: require('../../../../assets/imgs/teacher.png'),
      inSrc: '' // 图片编辑弹窗传入图片地址
    }
  },
  mounted () {
    this.getTaskActivityAndClassList()
    this.calculateText()
    this.correctContent = this.correctContentList[Math.floor(Math.random() * this.correctContentList.length)]
  },
  methods: {
    onSearch (value) {
      // 按照姓名搜索
      if (value === '') {
        this.$message.error('请输入查询内容')
      } else {
        this.pageNum = 1
        this.userName = value
        this.getTableList()
      }
    },
    editTime () {
      this.editTimeFlag = false
    },
    timeChange (value, dateString) {
      this.timeDate = dateString
    },
    timeOk (val) {
      this.timeDate = format.format(val)
    },
    calculateText () {
      this.$nextTick(() => {
        const twoHeight = 16 * 2
        this.textHeight = `${twoHeight}px`
        const curHeight = this.$refs.desc.offsetHeight
        if (curHeight > twoHeight) {
          this.status = true
          this.idShowText = true
        } else {
          this.status = false
          this.idShowText = false
        }
      })
    },
    getValue (data) {
      console.log(data)
    },
    getRole (item) {
      // 显示单个学生权限设置弹窗
      this.userAnswerId = item.userActivityRecordId
      this.personVis = true
    },
    globalPermission () {
      // 设置当前全局学生批改权限
      const param = {
        activityId: this.activityId,
        classId: this.classId,
        isClassStuRevise: this.classValue,
        type: this.personFlag === true ? 1 : 2,
        access_token: this.access_token
      }

      this.$http.post(requestUrl.setClassStuReviseGlobalPermission, param).then(res => {
        if (res) {
          this.getTableList()
          this.classVis = false
        }
      })
      this.classVis = false
    },
    getTaskActivityAndClassList () {
      console.log(this.$store.state.taskFeedBackMess)
      // 获取活动和发布班级详情
      const param = {
        id: this.$store.state.taskFeedBackMess.id,
        access_token: this.access_token
      }

      this.$http.post(requestUrl.getTaskActivityAndClassList, param).then(res => {
        if (res) {
          this.activityList = res.task.activityList
          this.activityMess = res.task.activityList[0] || {}
          this.activityId = res.task.activityList[0].id || {}
          this.taskId = res.task.id
          this.classList = res.classList
          this.endDate = res.endDate
          this.classId = res.classList[0].id || {}

          this.getTableList()
        }
      })
      this.classVis = false
    },
    singlePermission () {
      // 设置当前单个学生批改权限
      const param = {
        id: this.userAnswerId,
        isClassStuRevise: this.personvalue,
        access_token: this.access_token
      }

      this.$http.post(requestUrl.setClassStuReviseSinglePermission, param).then(res => {
        if (res) {
          this.getTableList()
          this.personVis = false
        }
      })
      // this.personVis = false
    },
    changeActivity (item, index) {
      this.activityCurrent = index
      this.activityMess = item
      this.activityId = item.id
      this.getTableList()
      this.calculateText()
    },
    changeClass (item, index) {
      this.classCurrent = index
      this.classId = item.id
      this.getTableList()
    },
    changePageNum (pageNum) {
      this.pageNum = pageNum
      this.getTableList()
    },
    onShowSizeChange (current, pageSize) {
      this.pageSize = pageSize
      this.getTableList()
    },
    submitRecordshandleCancel () {
      // 提交记录--取消
      this.submitRecordsVisible = false
    },
    starRange (e) { // 星星数量设置
      this.starValue = e
    },
    setGoodChange (e) {
      if (e.target.checked) {
        this.isGood = 1
      } else {
        this.isGood = 0
      }
    },
    pgFun (item, flag) {
      // console.log(item)
      console.log(item.workStatus)
      this.pgWorkStatus = item.workStatus
      if (item.workStatus === 1 || item.workStatus === 4) {
        // 批改
        this.look = flag
        this.isReviseFlag = item.isRevise === 1
        this.userAnswerId = item.userActivityRecordAnswerId
        const param = {
          id: item.userActivityRecordId,
          teacherId: this.userId,
          access_token: this.access_token
        }
        this.$http.post(requestUrl.getTaskActivityAnswerViewWithRecordById, param).then(res => {
          if (res) {
            this.correctDetail = res
            this.replayVis = true

            // 将列表的推荐状态，传递给批改页面
            this.isGood = item.isGood

            this.correctContent = this.correctContentList[Math.floor(Math.random() * this.correctContentList.length)]
            //  console.log(this.correctDetail)
            // this.starValue = res.userActivityRevise && res.userActivityRevise.star
          }
        })
      } else if (item.workStatus === 2) {
        // 已打回
        this.$message.warning('已打回状态下，活动不可批改')
      } else if (item.workStatus === 3) {
        // 查看详情
        // this.goDetail(item, true)
        this.look = flag
        this.isReviseFlag = item.isRevise === 1
        this.userAnswerId = item.userActivityRecordAnswerId
        const param = {
          id: item.userActivityRecordAnswerId,
          teacherId: this.userId,
          access_token: this.access_token
        }
        this.$http.post(requestUrl.getAnswerWithReviseById, param).then(res => {
          if (res) {
            this.correctDetail = res
            this.replayVis = true

            // 将列表的推荐状态，传递给批改页面
            this.isGood = res.isGood
            //  console.log(this.correctDetail)
            // this.correctDetail.star = (res.userActivityRevise && res.userActivityRevise.star) || 0
            // this.correctContent = (res.userActivityRevise && res.userActivityRevise.content) || ''
            this.correctDetail.answerContent = res.writingContent || ''
          }
        })
      } else {
        // 查看详情
        // this.goDetail(item, true)
        this.look = flag
        this.isReviseFlag = item.isRevise === 1
        this.userAnswerId = item.userActivityRecordAnswerId
        const param = {
          id: item.userActivityRecordAnswerId,
          teacherId: this.userId,
          access_token: this.access_token
        }
        this.$http.post(requestUrl.getAnswerWithReviseById, param).then(res => {
          if (res) {
            this.correctDetail = res
            this.replayVis = true

            // 将列表的推荐状态，传递给批改页面
            this.isGood = res.isGood
            //  console.log(this.correctDetail)
            this.correctDetail.star = (res.userActivityRevise && res.userActivityRevise.star) || 0
            this.correctContent = (res.userActivityRevise && res.userActivityRevise.content) || ''
            this.correctDetail.answerContent = res.writingContent || ''
          }
        })
      }
    },
    goDetail (item, flag) {
      // 查看详情
      this.look = flag

      this.isReviseFlag = item.isRevise === 1
      this.userAnswerId = item.userActivityRecordAnswerId

      const param = {
        id: item.userActivityRecordId,
        userId: this.userId,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getTaskActivityAnswerViewWithRecordById, param).then(res => {
        if (res) {
          // todo 模拟点赞数据
          // if (res.revises == null) {
          //   res.revises = []
          //   res.revises.push({
          //     userName: '批改人名称',
          //     photo: '',
          //     star: 3,
          //     content: '批改内容',
          //     createDate: 1678860681000,
          //     praiseCount: 10,
          //     isPraise: 1
          //   })
          // }

          this.correctDetail = res
          this.taskDetailVis = true
          console.log(res)
          console.log(this.correctDetail)
          console.log(this.$getUserInfo())
          //  this.starValue = res.userActivityRevise && res.userActivityRevise.star
        }
      })
      // this.replayVis = true
    },
    commitHistory (item) {
      const param = {
        id: item.userActivityRecordId,
        teacherId: this.userId,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.getUserCommitHistoryList, param).then(res => {
        this.submitInfo = res
        this.submitRecordsVisible = true
      })
    },
    recommandFun (item) {
      // 推荐/取消推荐活动
      if (item.workStatus === 1) {
        return
      }
      if (item.isGood === 1) {
        this.userAnswerId = item.userActivityRecordId
        this.cancelGood = true
      } else {
        this.userAnswerId = item.userActivityRecordId
        this.recommandVis = true
      }
    },
    recommandSure () {
      // 推荐作品
      const param = {
        id: this.userAnswerId,
        viewPermission: this.recommendValue,
        recommendComment: this.commenttContent,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.setGood, param).then(res => {
        if (res) {
          this.$message.success('推荐作品成功～')
          this.recommandVis = false
          this.getTableList()
        } else {
          this.$message.warn(res.resultMessage)
        }
      })
    },
    cancelGoodSure () {
      // 取消推荐作品
      const param = {
        id: this.userAnswerId,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.cancelGood, param).then(res => {
        if (res) {
          this.$message.success('取消推荐成功～')
          this.cancelGood = false
          this.getTableList()
        } else {
          this.$message.warn(res.resultMessage)
        }
      })
    },
    saveFun () {
      const param = {
        id: this.userAnswerId,
        teacherId: this.userId,
        content: this.correctContent,
        isGood: this.isGood,
        star: this.starValue,
        audioList: [],
        imageList: this.fileList,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.saveActivityRevise, param).then(res => {
        if (res) {
          this.$message.success('保存活动批改成功')
          this.replayVis = false
        } else {
          this.$message.warning(res.resultMessage)
        }
      })
    },
    reback () {
      // 任务批改 打回作业
      const param = {
        id: this.userAnswerId,
        teacherId: this.userId,
        access_token: this.access_token,
        content: this.correctContent
      }
      this.$http.post(requestUrl.reformActivity, param).then(res => {
        if (res) {
          this.getTableList()
          this.replayVis = false
          this.correctContent = ''
          this.fileList = []
        }
      })
    },
    publishFun () {
      // 每次作业都力求做的更漂亮！ 认真的程度再高一些，你的收获就会更多一些！ 每天前进一小步，你终会走向成功！
      if (this.correctContent === '') {
        this.$message.error('请输入批改内容')
        return
      }
      // 活动批改提交 根据答案id 进行批改
      const param = {
        id: this.userAnswerId,
        audioList: [],
        content: this.correctContent,
        imageList: this.fileList,
        isGood: this.isGood,
        star: this.starValue,
        teacherId: this.userId,
        recommendedPermission: this.classType,
        access_token: this.access_token
      }
      this.$http.post(requestUrl.commitActivityRevise, param).then(res => {
        if (res) {
          this.$message.success('批改成功')
          this.replayVis = false
          this.correctContent = ''
          this.fileList = []
          this.getTableList()
        }
      })
    },
    praise (detail) {
      // 查看详情 评价列表点赞/取消点赞
      console.log('点赞')
      let praiseUrl = ''
      if (detail.isPraise === 0) {
        praiseUrl = requestUrl.taskActivityRevisePraise
      } else {
        praiseUrl = requestUrl.taskActivityReviseCancelPraise
      }
      const param = {
        id: detail.id,
        userId: this.userId,
        access_token: this.access_token
      }
      this.$http.post(praiseUrl, param).then(res => {
        if (res) {
          // this.$message.success('批改成功')
          if (detail.isPraise === 0) {
            detail.isPraise = 1
          } else {
            detail.isPraise = 0
          }
        } else {
          this.$message.warning(res.resultMessage)
        }
      }
      )
    },
    getTableList () {
      // 获取任务反馈学生回答列表
      if (this.classId !== '') {
        // 班级解散后，班级id没有返回，后台接口返回报错
        this.personFlag = this.$store.state.taskFeedBackMess.taskType === 1 // 1 个人任务 2 小组任务
        const url = this.$store.state.taskFeedBackMess.taskType === 1 ? requestUrl.getPersonalAnswerPage : requestUrl.getGroupAnswerPage
        if (this.personFlag) {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'sequenceId',
              align: 'center',
              width: 60,
              customRender: (text, record, index) => index + 1
            },
            { title: '姓名', dataIndex: 'userName', key: 'userName', align: 'center', width: 100 },
            {
              title: '',
              dataIndex: 'recommendedPermission',
              key: 'recommendedPermission',
              scopedSlots: { customRender: 'recommendedPermission' },
              align: 'left',
              width: 40
            },
            {
              title: '批改人',
              dataIndex: 'reviseUserNames',
              key: 'reviseUserNames',
              scopedSlots: { customRender: 'reviseUserNames' },
              align: 'center',
              width: 120
            },
            // { title: '回答详情', dataIndex: 'writingContent', key: 'writingContent',scopedSlots: { customRender: 'writingContent' },ellipsis: true },
            {
              title: '批改状态',
              dataIndex: 'workStatus',
              key: 'workStatus',
              scopedSlots: { customRender: 'workStatus' },
              align: 'center',
              width: 100
            },
            {
              title: '提交时间',
              dataIndex: 'commitDate',
              key: 'commitDate',
              scopedSlots: { customRender: 'commitDate' },
              align: 'center',
              width: 120
            },
            // { title: '批改状态', dataIndex: 'status', key: 'status', width: 90 },
            {
              title: '成绩（教师打分成绩）',
              dataIndex: 'star',
              key: 'star',
              scopedSlots: { customRender: 'star' },
              align: 'center',
              width: 160
            },
            {
              title: '权限',
              dataIndex: 'isClassStuRevise',
              key: 'isClassStuRevise',
              align: 'center',
              width: 110,
              scopedSlots: { customRender: 'isClassStuRevise' }
            },
            {
              title: '操作',
              dataIndex: '',
              key: 'action',
              align: 'center',
              width: 270,
              scopedSlots: { customRender: 'action' }
            }
          ]
        } else {
          this.columns = [
            {
              title: '序号',
              dataIndex: 'sequenceId',
              align: 'center',
              width: 60,
              customRender: (text, record, index) => index + 1
            },
            { title: '小组名', dataIndex: 'groupName', ellipsis: true, key: 'groupName', align: 'center', width: 100 },
            {
              title: '',
              dataIndex: 'recommendedPermission',
              ellipsis: true,
              key: 'recommendedPermission',
              scopedSlots: { customRender: 'recommendedPermission' },
              width: 40
            },
            { title: '组长', dataIndex: 'userName', ellipsis: true, key: 'userName', align: 'center', width: 120 },
            // { title: '回答详情', dataIndex: 'writingContent', key: 'writingContent',scopedSlots: { customRender: 'writingContent' },ellipsis: true },
            {
              title: '批改状态',
              dataIndex: 'workStatus',
              key: 'workStatus',
              scopedSlots: { customRender: 'workStatus' },
              align: 'center',
              width: 100
            },
            {
              title: '提交时间',
              dataIndex: 'commitDate',
              key: 'commitDate',
              scopedSlots: { customRender: 'commitDate' },
              align: 'center',
              width: 120
            },
            {
              title: '成绩',
              dataIndex: 'star',
              key: 'star',
              align: 'center',
              scopedSlots: { customRender: 'star' },
              width: 180
            },
            {
              title: '批改人',
              dataIndex: 'reviseUserNames',
              key: 'reviseUserNames',
              scopedSlots: { customRender: 'reviseUserNames' },
              align: 'center',
              width: 100
            },
            {
              title: '权限',
              dataIndex: 'isClassStuRevise',
              key: 'isClassStuRevise',
              align: 'center',
              width: 110,
              scopedSlots: { customRender: 'isClassStuRevise' }
            },
            {
              title: '操作',
              dataIndex: '',
              key: 'action',
              width: 270,
              align: 'center',
              scopedSlots: { customRender: 'action' }
            }
          ]
        }
        const param = {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
          taskId: this.taskId,
          activityId: this.activityId,
          classId: this.classId,
          userName: this.userName,
          access_token: this.access_token
        }
        this.$http.post(url, param).then(res => {
          this.tableList = res.list
          this.total = res.total
        })
      }
    },
    getUrlImg (data) {
      // 收到编辑成功的图片地址
      this.fileList.push({
        name: '图片',
        path: data
      })
      this.imgEditorVisible = false
    },
    doImageEdit (src) {
      // 编辑图片
      console.log('要编辑的图片地址：' + src)
      this.inSrc = src
      this.imgEditorVisible = true
    },
    disabledDate (current) {
      return current && current < moment().subtract(1, 'days')
    },
    classSetFun () {
      //  设置当前全局学生批改权限设置
      this.classVis = true
    },
    beforeUpload (file) {
      if (this.fileList.length > 6) {
        this.$message.warning('最多上传6张图片')
        return
      }
      const isLt2M = file.size / 1024 / 1024 < 3
      if (!isLt2M) {
        this.$message.error('上传的图片大小不能大于3MB!')
        return
      }
      const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/jpg'
      if (!isJpgOrPng) {
        this.$message.error('请您上传jpeg或png或jpg格式图片')
        return
      }
      const formData = new FormData()
      formData.append('file', file)
      formData.append('customDir', 'hytc_ebook_server/file')
      formData.append('access_token', this.access_token || '')
      // 上传图片方法
      const _this = this
      axios({
        url: _this.$uploadUrl,
        method: 'post',
        data: formData,
        headers: { 'Content-Type': 'multipart/form-data' }
      }).then(res => {
        if (res && res.status === 200) {
          _this.fileList.push({
            fileName: res.data.fileName,
            id: res.data.fileName,
            path: res.data.url
          })
        }
      })
    },
    delFun (index) {
      this.fileList.splice(index, 1)
    },
    submitRecordtabBack (index) {
      // 提交记录--切换活动
    },
    submitSeeAll (index) {
      // 查看原文
    },
    rowclick (i, j) {
      console.log(i, j)
    },
    classCancel () {
      this.classVis = false
    },
    replayCancel () {
      this.replayVis = false
    }
  },
  components: {
    RichTextView,
    ImageEditor
  }
}

</script>

<style lang="less" scoped>
.todo {
  padding: 20px 25px;
  background: #fff;
  border-radius: 15px;
  width: 98%;
  margin: 30px 20px 30px 20px;
  height: calc(100vh - 185px);
  // max-height: 600px;
  overflow-y: auto;

  .task-remind {
    color: #333;
    font-weight: 600;
    font-size: 18px;
    line-height: 40px;
  }

  .s-title {
    font-size: 16px;
    color: #333;
    line-height: 35px;
    font-weight: 600;
  }

  .activity-list {
    height: 40px;
    line-height: 40px;
    font-size: 16px;

    .activitySpan {
      margin-right: 20px;
      cursor: pointer;
    }

    .activityAct {
      color: @primary-color;
      margin-right: 20px;
      cursor: pointer;
    }
  }

  .activity-detail {
    background: rgba(196, 154, 97, .2);
    // padding-top: 22px;

    // margin-bottom: 16px;
    padding: 8px 15px;
    position: relative;

    .titleText {
      font-size: 14px;
    }

    .openClose {
      font-size: 14px;
      color: @primary-color;
      cursor: pointer;
    }

    .openSpan {
      position: absolute;
      right: 2px;
      top: 8px;
      width: 48px;
      height: 25px;
      z-index: 99;
      text-align: center;
      // background: rgba(196, 154,97, .2);
      color: @primary-color;
    }

    .statusText {
      width: calc(100% - 50px);
      overflow: hidden;
      display: block;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .reply-detail {
    line-height: 50px;
    color: #797979;
  }

  .class-list {
    display: flex;

    .list-l {
      .classAct {
        padding: 4px 15px;
        color: #867D7B;
        background: #F1F0F0;
        font-size: 14px;
        cursor: pointer;
        margin-right: 10px;
      }

      .classSpan {
        padding: 4px 10px;
        color: #fff;
        background: @primary-color;
        font-size: 14px;
        cursor: pointer;
        margin-right: 10px;
      }
    }

    .list-r {
      margin-left: auto;

      cursor: pointer;

      .img-jz {
        margin-top: -2px;
      }

      .time-jz {
        margin-left: 3px;
      }

      .time-number {

      }

      .time-edit {
        margin-left: 10px;
        color: @primary-color;
        cursor: pointer;
      }

      img {
        width: 16px;
        height: 16px;
        margin-right: 4px;
        margin-left: 10px;
      }

      .qx-text {
        color: @primary-color;
      }
    }
  }

  .table {
    margin-top: 15px;

    .ant-dropdown-link {
      color: @primary-color;
      cursor: pointer;
    }

    .commitDateNor {

    }

    .commitDateRed {
      color: red;
    }

    .action {
      span {
        color: @primary-color;
        cursor: pointer;
        border: 1px solid @primary-color;
        padding: 2px 4px;
        margin-right: 8px;
        border-radius: 2px;
        white-space:normal;
        word-wrap:break-word;
      }

      .feedBack-no {
        color: #BDBDBD;
        border: 1px solid #BDBDBD;
        padding: 2px 4px;
        margin-right: 10px;
        border-radius: 2px;
        cursor: not-allowed
      }

      .correctDis{
        white-space:normal;
        word-wrap:break-word;
      }
    }

  }
}

// 任务批改
.replay {
  padding: 0px;

  .author {
    display: flex;
    line-height: 25px;

    .author-img {
      width: 14px;
      height: 14px;
      margin-top: 5px;
    }

    .author-name {
      color: @primary-color;
      font-size: 16px;
      margin-left: 10px;
    }
  }

  .content {
    margin-top: 20px;
    min-height: 200px;
    // width: 300px;
  }

  .file-imgs {
    cursor: pointer;
    position: relative;
    width: 120px;
    height: 100px;
    margin-left: 5px;

    .file-im {
      .file-img {
        width: 120px;
        height: 100px;
        cursor: pointer;
      }

      .del {
        position: absolute;
        cursor: pointer;
        right: 0;
        top: 0;
        z-index: 9;
        width: 16px;
        height: 16px;
      }

      &:first-child {
        margin-left: 0px;
      }
    }
  }

  .good {
    line-height: 30px;
    margin-top: 10px;
    display: flex;
    flex-direction: row-reverse;

    img {
      width: 14px;
      height: 14px;
      cursor: pointer;
      margin-left: 15px;
    }

    .number {
      color: #867D7B;
      font-size: 14px;
      margin-left: 5px;
      margin-top: -8px;
    }
  }

  .pj {
    display: flex;

    .stu {
      color: @primary-color;
      font-size: 14px;
      line-height: 36px;
    }

    .text {
      margin-left: 5px;
      display: inline-block;
      line-height: 35px;
    }

    .xing {
      margin-top: -5px;
    }

    margin-bottom: 10px;

    .pj-right {
      margin-left: auto;
      display: flex;

      .rec {
        margin-top: 3px;
        margin-right: 10px;
      }

      .text-pz {
        color: @primary-color;
      }

      .good {
        margin-top: 4px;
      }
    }
  }

  .text {
    font-size: 16px;
    font-weight: 400;
    color: #000000;
    line-height: 24px;
  }

  // 查看详情
  .file-list {
    margin: 10px 0 0 0;
    display: flex;
    width: 100%;

    .pj {
      margin-bottom: 0px;

      .userImg {
        width: 30px;
        height: 30px;
        margin-right: 5px;
      }

      .stu {
        margin-right: 15px;
        font-weight: 600;
        color: #000000;
        font-size: 16px;
      }
    }

    .pj-detail {
      margin-left: 35px;
      color: #000000;
      font-weight: 400;
      font-size: 14px;
    }

    .time {
      margin-top: 5px;

      .time-number {
        margin-left: 35px;
        color: #867D7B;
        font-size: 12px;
        font-weight: 400;
      }

      .text {
        float: right;
        font-size: 12px;
        font-weight: 400;
        color: #867D7B;
        line-height: 12px;

        .praise {
          width: 15px;
          height: 15px;
          margin-right: 3px;
        }
      }
    }

    .file-div {
      cursor: pointer;
      position: relative;
      width: 106px;
      height: 60px;
      margin-left: 5px;

      .file-img {
        width: 100px;
        height: 80px;
        cursor: pointer;
        margin-left: 30px;
        border-radius: 8px;
      }

      .del {
        position: absolute;
        cursor: pointer;
        right: 0;
        top: 0;
        z-index: 9;
        width: 16px;
        height: 16px;
      }

      &:first-child {
        margin-left: 0px;
      }
    }
  }

  .footer {
    display: flex;
    margin-top: 20px;

    .upload-btn {
      .add {
        width: 20px;
        height: 20px;
        margin-top: 2px;
        margin-right: 10px;
        cursor: pointer;
      }
    }

    .fun-btn {
      margin-left: auto;

      .save {
        margin-right: 20px;
      }

      .fb {
        // margin-left: 20px;
      }
    }
  }
}

.tj {
  .use {
    line-height: 20px;
    color: @primary-color;
  }

  .use-content {
    min-height: 90px;
    // background-color: #f2f2f2;
    border-radius: 5px;
    margin-top: 15px;
  }

  .use-footer {
    display: flex;
    margin-top: 20px;

    .rec {
      margin-top: 3px;
    }

    .recommand {
      margin-left: auto;
    }
  }
}

/deep/ .ant-divider-horizontal {
  margin: 12px 0;
}

.select-rolef {
  color: @primary-color;

  /deep/ .ant-select-selection {
    border: none;
  }

  /deep/ .ant-select {
    width: 80px !important;
    color: @primary-color;
  }
}

.qx-footer {
  width: 160px;
  margin: 0 auto;
  margin-top: 15px;
  display: flex;

  .qx-cancel {

  }

  .qx-sure {
    margin-left: auto;
  }
}

.writingContentClass {
  display: inline-block;
  overflow: hidden;
  height: 30px;
  text-overflow: ellipsis;
  white-space: nowrap;
  // -webkit-line-clamp: 1;
  // -webkit-box-orient: vertical;
}

// 提交记录
.records-time-box {
  /deep/ .ant-tabs-nav .ant-tabs-tab {
    position: relative;
    display: inline-block;
    box-sizing: border-box;
    height: 100%;
    margin: 0 0px 0 0;
    padding: 2px 16px;
    width: 140px;
    background: #F1F0F0;
    text-decoration: none;
    cursor: pointer;
    transition: color 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    text-align: center;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #867D7B;
    border-radius: 2px;
    border: 0px solid #ffffff;
  }

  /deep/ .ant-tabs-nav .ant-tabs-tab-active {
    text-shadow: 0 0 0.25px currentColor;
    background: #db5647;
    color: #ffffff;
  }

  /deep/ .ant-tabs-bar {
    border-bottom: 1px solid #fff;
  }

  .submit-info {
    .submit-info-top {
      display: flex;
      justify-content: space-between;

      .submit-info-top-left {
        .sub-num {
          font-size: 16px;
          font-weight: 600;
          color: #000000;
          margin-right: 20px;
        }

        .sub-time {
          font-size: 12px;
          font-weight: 400;
          color: #867D7B;
        }
      }

      .submit-info-top-right {
        span {
          font-size: 14px;
          font-weight: 400;
        }

        .sub-state {
          color: #867D7B;
        }
      }
    }

    .submit-info-content-box {
      width: 100%;
      background: #F1F0F0;
      border-radius: 8px;
      padding: 12px 20px 12px 20px;
      box-sizing: border-box;
      margin-top: 12px;

      .submit-info-content {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        word-break: break-all;

      }

      .submit-info-seeAll {
        font-size: 14px;
        font-weight: 400;
        color: @primary-color;
        margin-top: 10px;
      }
    }

    .sub-comments {
      margin-top: 20px;

      .sub-wenzi {
        font-size: 16px;
        font-weight: 600;
        color: @primary-color;
      }

      .sub-comments-content {
        margin-top: 12px;

      }
    }
  }
}

/deep/ .ant-table-thead > tr > th {
  border: none;
}

/deep/ .ant-table-tbody > tr {
  border-bottom: 1px solid #e8e8e8 !important;
}

/deep/ .ant-table-tbody > tr > td {
  border: none;
  border-bottom: 1px solid #e8e8e8 !important;
}

.wj-new {
  margin: 10px auto 40px auto;
  text-align: center;
  width: 200px;

  .del-text {
    font-size: 16px;
    color: black;
  }
}

.qx-footer {
  width: 160px;
  margin: 0 auto;
  margin-top: 15px;
  display: flex;

  .qx-cancel {

  }

  .qx-sure {
    margin-left: auto;
  }
}

/deep/.ant-modal-body {
  max-height: calc(80vh - 50px);
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 6px;
    /*高宽分别对应横竖滚动条的尺寸*/
    height: 1px;
  }

  &::-webkit-scrollbar-thumb {
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #e3e3e6;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 5px;
  }
}
</style>
